import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Divider,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { Link, useLocation } from "react-router-dom";

const navItems = [
  { label: "Home", path: "/" },
  { label: "About Us", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Gallery", path: "/gallery" },
  { label: "Projects", path: "/projects" },
  { label: "Career", path: "/career" },
 // { label: "Blog", path: "/blog" },
  { label: "Contact Us", path: "/contact" },
];

const Navbar = () => {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  // Drawer content for mobile
  const drawer = (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#fff",
        py: 3,
        px: 2,
      }}
    >
      <List sx={{ width: "100%", p: 0, m: 0 }}>
        {navItems.map((item, index) => (
          <Box key={index} sx={{ width: "100%" }}>
            <ListItem disablePadding sx={{ m: 0, p: 0 }}>
              <ListItemButton
                component={Link}
                to={item.path}
                onClick={handleDrawerToggle}
                sx={{
                  textAlign: "center",
                  py: 1.5,
                  borderRadius: "8px",
                  backgroundColor:
                    location.pathname === item.path ? "#22538b0f" : "transparent",
                  "&:hover": {
                    backgroundColor: "#22538b15",
                    transform: "scale(1.02)",
                  },
                }}
              >
                <ListItemText
                  primary={item.label}
                  sx={{
                    textAlign: "center",
                    "& .MuiTypography-root": {
                      color:
                        location.pathname === item.path ? "#22538bff" : "#333",
                      fontWeight:
                        location.pathname === item.path ? 700 : 500,
                      fontSize: "1.05rem",
                      letterSpacing: "0.5px",
                    },
                  }}
                />
              </ListItemButton>
            </ListItem>
            {index !== navItems.length - 1 && (
              <Divider sx={{ my: 1, backgroundColor: "#e0e0e0" }} />
            )}
          </Box>
        ))}
      </List>

      <Box sx={{ mt: "auto", textAlign: "center", py: 2 }}>
        <Typography variant="body2" sx={{ color: "#777", fontSize: "0.85rem" }}>
          © {new Date().getFullYear()} Anagha Engineers
        </Typography>
      </Box>
    </Box>
  );

  return (
    <Box sx={{ flexGrow: 1 }}>
      {/* Header with logo and hamburger (shared for all views) */}
      <Box
        sx={{
          backgroundColor: "#fff",
          padding: { xs: "10px 18px", md: "15px 20px" },
          display: "flex",
          alignItems: "center",
          justifyContent: { xs: "space-between", md: "flex-start" },
          gap: 2,
          marginLeft: { md: "80px" },
          maxWidth: { md: "80%" },
          position: "sticky",
          top: 0,
          zIndex: 1201,
          borderBottom: "1px solid #eaeaea",
        }}
      >
        <Box display="flex" alignItems="center" gap={1.5}>
          <img
            src="homepage/anagha.png"
            alt="Anagha Engineers"
            style={{ height: "55px", width: "auto" }}
          />
          <Typography
            variant="h6"
            sx={{
              color: "#22538bff",
              fontWeight: "bold",
              fontSize: { xs: "1rem", sm: "1.25rem" },
              letterSpacing: "0.5px",
              whiteSpace: "nowrap",
            }}
          >
            ANAGHA ENGINEERS
          </Typography>
        </Box>

        {/* Hamburger icon only on mobile */}
        <IconButton
          onClick={handleDrawerToggle}
          sx={{
            display: { xs: "block", md: "none" },
            ml: "auto",
            color: "#22538bff",
          }}
        >
          {mobileOpen ? (
            <CloseIcon sx={{ fontSize: 28 }} />
          ) : (
            <MenuIcon sx={{ fontSize: 28 }} />
          )}
        </IconButton>
      </Box>

      {/* Desktop Navbar (unchanged layout) */}
      <AppBar
        position="sticky"
        sx={{
          backgroundColor: "#f9f9f9",
          boxShadow: "none",
          width: "100vw",
          left: 0,
          right: 0,
          margin: 0,
          padding: 0,
          display: { xs: "none", md: "block" },
        }}
      >
        <Toolbar sx={{ minHeight: "64px", paddingLeft: 0, paddingRight: 0 }}>
          <Box
            sx={{
              display: "flex",
              gap: 4,
              width: "100%",
              justifyContent: "center",
            }}
          >
            {navItems.map((item) => (
              <Button
                key={item.label}
                component={Link}
                to={item.path}
                sx={{
                  color: "#22538bff",
                  backgroundColor: "transparent",
                  fontWeight: "bold",
                  textTransform: "none",
                  borderRadius: 0,
                  px: 2,
                  borderBottom:
                    location.pathname === item.path
                      ? "2px solid #22538bff"
                      : "2px solid transparent",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    borderBottom: "2px solid #22538bff",
                    backgroundColor: "transparent",
                  },
                }}
              >
                {item.label}
              </Button>
            ))}
          </Box>
        </Toolbar>
      </AppBar>

      {/* Drawer for mobile */}
      <Drawer
        anchor="top"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": {
            height: "100vh",
            top: "64px",
            backgroundColor: "#fff",
            boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
            transition: "all 0.3s ease",
          },
        }}
      >
        {drawer}
      </Drawer>
    </Box>
  );
};

export default Navbar;
